<template>
    <button class="btn-style btn-layout" @click="onClickHandler">
        <img
            v-show="loading"
            class="loader"
            src="../assets/images/loading-circle.svg"
            alt=""
        />
        <div class="text-style">
            {{ text }}
        </div>
    </button>
</template>

<script>
export default {
    name: "PrimaryButton",
    props: {
        loading: {
            type: Boolean,
            default: false
        },
        text: {
            type: String,
            default: ""
        }
    },
    methods: {
        onClickHandler() {
            this.$emit("clickHandler");
        }
    }
}
</script>

<style lang="scss" scoped>
.btn-layout {
    display: inline-flex;
    padding: 20px;
    justify-content: center;
    align-items: center;
    gap: 10px;
}

.btn-style {
    border-radius: 10px;
    border: 2px solid var(--primary-ada-blue-100, #007AA3);
    box-shadow: 0px 3px 5px -1px rgba(30, 30, 37, 0.10), 0px 6px 10px 0px rgba(30, 30, 37, 0.16);
    background-color: unset;
    cursor: pointer;
    transition: background-color 100ms linear;

    &:hover {
        background-color: var(--primary-ada-blue-100, #007AA3);
        transition: background-color 100ms linear;


        .text-style {
            color: var(--shades-white-ffffff, #FFF);
        }
    }

    &:active {
        background: var(--primary-ada-blue-100, #004E69);

        .text-style {
            color: var(--shades-white-ffffff, #FFF);
        }
    }
}

.text-style {
    color: var(--primary-ada-blue-100, #007DA7);
    text-align: center;
    text-shadow: 0.5px 0.5px 1px 0px rgba(30, 30, 37, 0.30);
    font-family: Poppins;
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: 25px;
    letter-spacing: 0.32px;
}
</style>